<template>
  <PropertyLabel :name="name" v-if="value">
    <template>
      <br />
      <span class="has-text-black has-text-weight-medium">{{
        value | emptyValueToText | tryToLocaleDateTime
      }}</span>
    </template>
  </PropertyLabel>
</template>
<script>
import PropertyLabel from "./PropertyLabel";
export default {
  props: ["name", "value"],
  components: {
    PropertyLabel,
  },
};
</script>